import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import './ErrorMessage.scss';

function handleReload() { window.location.reload(); }

function ErrorMessage({ message, onReload }) {
  return (
    <center className="ErrorMessage">
      {message}
      <br />
      <FormattedMessage id="components.errorMessage.message.contentItem1" />&nbsp;
      <span
        className="ErrorMessage__HyperLink"
        role="button"
        tabIndex="-1"
        onClick={onReload}
      >
        <FormattedMessage id="components.errorMessage.reload.buttonLabel" />
      </span>&nbsp;
      <FormattedMessage id="components.errorMessage.message.contentItem2" />
    </center>
  );
}
ErrorMessage.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onReload: PropTypes.func
};

ErrorMessage.defaultProps = {
  message: <FormattedMessage id="components.errorMessage.message.default" />,
  onReload: handleReload
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.jsx